// File: src/pages/Value.jsx
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Value() {
    return (
        <section className="bg-white text-black px-6 md:px-20 py-20 font-sans overflow-hidden">
            <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">

                {/* Left Side */}
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <p className="text-sm font-medium tracking-widest uppercase mb-2">
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500">Our Values</span>
                    </p>
                    <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-8">
                        Our values are the <br className="hidden md:block" />
                        foundation of everything we do.
                    </h2>

                    <div className="space-y-6 text-gray-700">
                        <div>
                            <h3 className="text-xl font-semibold text-black">Integrity</h3>
                            <p>We uphold the highest standards of honesty and transparency in all our interactions.</p>
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800">Innovation</h3>
                            <p>We are dedicated to fostering a culture of creativity and forward-thinking.</p>
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800">Excellence</h3>
                            <p>We strive for excellence in every project and service we deliver.</p>
                        </div>
                    </div>
                </motion.div>

                {/* Right Side */}
                <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="relative group"
                >
                    <img
                        src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=800&q=80"
                        alt="Team working"
                        className="rounded-xl shadow-xl border border-gray-100"
                    />

                    {/* Floating Button */}
                    <Link
                        to="/company"
                        className="absolute top-4 left-4 bg-white text-black px-4 py-2 rounded-full shadow-md hover:shadow-lg transition"
                    >
                        About company
                    </Link>

                    {/* Glowing Border Effect */}
                    <div className="absolute inset-0 rounded-xl z-[-1] bg-gradient-to-r from-green-400 via-blue-500 to-purple-500 blur-2xl opacity-10 group-hover:opacity-30 transition duration-500"></div>
                </motion.div>
            </div>
        </section>
    );
}
